export const replaceLocation = (url: string | URL): void => {
  window.location.replace(url.toString());
};

export const setLocationPathname = (pathname: string): void => {
  window.location.pathname = pathname;
};
